// src/layout/builders/ProjectCompleted/CompletedTable.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import useProjectStatus from "../../../store/builders/useProjectStatus";
import ProjectTable from "../ProjectTable";
// Removed modal-specific imports like FileText, X, ArrowUpRightIcon, motion, AnimatePresence, ClipLoader
// as these are now handled by ProjectTable.jsx

const CompletedTable = () => {
  const navigate = useNavigate();
  const {
    projects,
    isLoading,
    fetchProjects,
    updateProjectStatus, // Kept for consistency, though not directly used for status change here
    // Removed checkCompletionDocumentsStatus and modal-related state/functions
  } = useProjectStatus();

  useEffect(() => {
    fetchProjects("completed");
  }, [fetchProjects]);

  const handleStatusChange = async (projectId, newStatus, comment = null) => {
    // This handler might not be strictly needed if status change is disabled,
    // but keep it for consistency or future changes.
    await updateProjectStatus(projectId, newStatus, comment);
    fetchProjects("completed"); // Refresh current view
  };

  if (isLoading && !projects.length) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <>
      {/* 
        The modal for viewing documents is now handled by ProjectTable.jsx itself.
        No need to render it here.
      */}
      <ProjectTable
        title="Completed Projects"
        projects={projects}
        handleStatusChange={handleStatusChange}
        navigate={navigate}
        allowedNextStatuses={[]} // No status changes allowed from this view directly
        showActionsColumn={true} // Ensure actions column is shown
        isCompletedView={true}
        // Removed the extraActions prop for the "Docs" button
      />
      {/* Removed <style jsx> as it's related to the modal now in ProjectTable */}
    </>
  );
};

export default CompletedTable;